// filepath: src/store/services/apiClient.js
import axios from "axios";

const baseURL =
  process.env.REACT_APP_API_BASE_URL || "https://api.bucket-001.online";

const apiClient = axios.create({
  baseURL,
  headers: {
    "Content-Type": "application/json",
  },
});

export default apiClient;
